<template>
  <DialogRoot
    :open="isSearchPaletteOpen"
    @open-change="(details) => { if (!details.open) { closeSearchPalette(); query = ''; } }"
  >
    <Teleport to="body">
      <DialogBackdrop class="fixed inset-0 z-50 bg-black/25 backdrop-blur-xs transition-opacity duration-200 data-[state=open]:opacity-100 data-[state=closed]:opacity-0" />
      <DialogPositioner class="fixed inset-0 z-50 w-screen overflow-y-auto px-4 py-20">
        <DialogContent class="mx-auto max-w-2xl overflow-hidden rounded-lg bg-white shadow-2xl ring-1 ring-gray-400 transition-all duration-200 data-[state=open]:opacity-100 data-[state=open]:scale-100 data-[state=closed]:opacity-0 data-[state=closed]:scale-95">
          <GlobalSearchPalette />
        </DialogContent>
      </DialogPositioner>
    </Teleport>
  </DialogRoot>
</template>

<script setup lang="ts">
import {
  DialogRoot,
  DialogBackdrop,
  DialogPositioner,
  DialogContent,
} from '@ark-ui/vue/dialog';
import useGlobalSearch from '@/Composables/useGlobalSearch';
import GlobalSearchPalette from '@/Components/GlobalSearchPalette.vue';

const {
  query,
  isSearchPaletteOpen,
  closeSearchPalette,
} = useGlobalSearch();
</script>
